<template>
  <fragment>
    <div
      id="pz-login-modal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      ref="pzLoginModal"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-dialog-centered login-modal"
        role="document"
      >
        <div class="modal-content" v-if="c_isLoginModal">
          <div class="d-flex justify-content-end mt-n5 mr-n1 mr-md-n5">
            <button
              type="button"
              class="close text-white mb-2 mb-md-0"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeLogin"
              @click="closeLogin"
            >
              <i class="pz-icon icon-close mt-3 mr-3"></i>
            </button>
          </div>

          <div class="modal-body p-0 pz-id">
            <!-- 手机登录 -->
            <div class="pz-id-login" v-if="!c_isLogin && '' === step">
              <div class="card border-0">
                <div class="wx-code collapse shadow" id="collapse-wx-code">
                  <!-- <div class="pt-4">
                  <h5 class="text-center">使用微信扫码</h5>
                </div>-->

                  <div id="loginModalHome" class="mb-3 mt-5">
                    <div class="wx-qrcode border">
                      <img
                        :src="ms_wechatQrcodeInfo.qrcode"
                        class="figure-img img-fluid"
                        width="220px"
                        height="220px"
                      />
                      <div
                        class="wx-qrcode-error-mask"
                        v-if="c_isQrcodeTimeout"
                      >
                        <p>二维码已失效</p>
                        <button
                          type="button"
                          class="btn btn-sm btn-danger"
                          @click.prevent="refreshWechatQrcode"
                        >
                          刷新
                        </button>
                      </div>
                    </div>
                    <p class="small">
                      <svg
                        class="mr-1"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <title>微信</title>
                        <g
                          id="页面-1"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            id="画板"
                            transform="translate(-203.000000, -150.000000)"
                            fill-rule="nonzero"
                          >
                            <g
                              id="微信"
                              transform="translate(203.000000, 150.000000)"
                            >
                              <rect
                                id="矩形"
                                fill="#000000"
                                opacity="0"
                                x="0"
                                y="0"
                                width="30"
                                height="30"
                              />
                              <path
                                d="M30,18.15 C30,13.95 25.95,10.65 21,10.65 C16.05,10.65 12,13.95 12,18.15 C12,22.35 16.05,25.65 21,25.65 C21.9,25.65 22.8,25.5 23.7,25.35 L26.55,26.85 L25.8,24.6 C28.35,23.1 30,20.85 30,18.15 L30,18.15 Z M17.85,16.95 C16.95,16.95 16.35,16.35 16.35,15.45 C16.35,14.55 16.95,13.95 17.85,13.95 C18.75,13.95 19.35,14.55 19.35,15.45 C19.35,16.2 18.6,16.95 17.85,16.95 Z M24,16.95 C23.1,16.95 22.5,16.35 22.5,15.45 C22.5,14.55 23.1,13.95 24,13.95 C24.9,13.95 25.5,14.55 25.5,15.45 C25.5,16.2 24.75,16.95 24,16.95 Z"
                                id="形状"
                                fill="#4CBF00"
                              />
                              <path
                                d="M10.5,17.85 C10.5,13.2 15,9.45 20.7,9.45 L21.15,9.45 C19.95,5.55 15.9,2.55 10.8,2.55 C4.8,2.55 0,6.6 0,11.55 C0,14.7 1.95,17.55 4.95,19.05 L4.05,21.75 L7.5,20.1 C8.55,20.4 9.6,20.55 10.8,20.55 L11.1,20.55 C10.65,19.65 10.5,18.75 10.5,17.85 L10.5,17.85 Z M14.55,5.7 C15.6,5.7 16.5,6.6 16.5,7.65 C16.5,8.7 15.6,9.6 14.55,9.6 C13.5,9.45 12.6,8.55 12.6,7.5 C12.6,6.45 13.5,5.7 14.55,5.7 L14.55,5.7 Z M7.2,9.45 C6.15,9.45 5.4,8.55 5.4,7.5 C5.4,6.45 6.3,5.55 7.35,5.55 C8.4,5.55 9.15,6.45 9.15,7.5 C9.15,8.55 8.25,9.45 7.2,9.45 Z"
                                id="形状"
                                fill="#4CBF00"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                      微信扫码登录
                    </p>
                    <p class="small">扫码关注公众号登录注册</p>
                  </div>
                  <button
                    class="btn btn-link btn-block mt-4"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapse-wx-code"
                    aria-expanded="false"
                    aria-controls="collapse-wx-code"
                    @click="closeWxcodeModal"
                  >
                    返回
                  </button>
                </div>
                <div class="card-body">
                  <div
                    class="d-flex justify-content-between align-items-center mb-4"
                  >
                    <div
                      class="nav nav-tabs login-tabs border-0 mb-3"
                      id="login-nav-tab"
                      role="tablist"
                    >
                      <a
                        class="nav-link f-18 active"
                        id="nav-login-tab"
                        data-toggle="tab"
                        href="#nav-login"
                        role="tab"
                        aria-controls="nav-login"
                        aria-selected="true"
                        @click="clearError"
                        >用户登录</a
                      >
                      <a
                        class="nav-link f-18"
                        id="nav-register-tab"
                        data-toggle="tab"
                        href="#nav-register"
                        role="tab"
                        aria-controls="nav-register"
                        aria-selected="false"
                        @click="clearError"
                        >注册账号</a
                      >
                    </div>
                  </div>

                  <div class="tab-content mb-3" id="login-nav-tabContent">
                    <!-- 登录 -->
                    <div
                      class="tab-pane fade show active"
                      id="nav-login"
                      role="tabpanel"
                      aria-labelledby="nav-login-tab"
                    >
                      <form id="formEmailModal">
                        <div class="tab-content" id="nav-tabContent">
                          <!-- 账号密码登录 -->
                          <div
                            class="tab-pane fade show active"
                            id="nav-mail"
                            role="tabpanel"
                            aria-labelledby="nav-mail-tab"
                          >
                            <div class="form-group mb-3">
                              <input
                                type="text"
                                v-model="username"
                                @change="handleChangeUsername"
                                class="form-control form-control-lg"
                                name="email"
                                placeholder="手机号/邮箱"
                                id="validationTooltip01"
                              />
                            </div>
                            <p
                              class="text-danger small"
                              v-show="false === isUsernameMobileExist"
                            >
                              您的手机号未注册品职账号，请您注册账号后再登录
                            </p>
                            <div class="mb-3">
                              <div class="input-group">
                                <input
                                  type="password"
                                  v-model="password"
                                  @change="clearError()"
                                  @keydown.enter="doLogin"
                                  class="form-control form-control-lg"
                                  name="password"
                                  placeholder="密码"
                                  id="validationTooltip0200"
                                />
                                <!-- <div class="input-group-append">
                            <router-link
                              class="btn btn-link border text-dark phone-code"
                              to="/password/forget"
                            >忘记密码?</router-link>
                              </div>-->
                              </div>
                            </div>
                          </div>

                          <div
                            class="tab-pane fade"
                            id="nav-phone"
                            role="tabpanel"
                            aria-labelledby="nav-phone-tab"
                          >
                            <form id="formMobile2">
                              <div class="mb-3">
                                <div class="input-group input-group-lg">
                                  <div
                                    class="input-group-prepend phone-reg dropup"
                                  >
                                    <button
                                      class="btn btn-link border text-dark dropdown-toggle"
                                      type="button"
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                      data-offset="-10,-50"
                                      @click.prevent="toggleRegionList"
                                    >
                                      {{ regionCountry + region }}
                                    </button>
                                    <div
                                      class="dropdown-menu shadow"
                                      :class="`${
                                        isRegionShown ? '' : 'd-none'
                                      }`"
                                    >
                                      <a
                                        href="javascript:undefined"
                                        @click.prevent="setRegionNo(regionNo)"
                                        class="dropdown-item"
                                        :key="`region-${idx}`"
                                        v-for="(regionNo, idx) in ms_regionNo"
                                      >
                                        {{ regionNo.countryName }}
                                        <span>{{
                                          regionNo.countryNumber
                                        }}</span>
                                      </a>
                                    </div>
                                  </div>
                                  <input
                                    type
                                    class="form-control"
                                    name="shortMobile"
                                    placeholder="输入手机号"
                                    v-model="shortMobile"
                                    @input="handleInputMobileAndCheckExist"
                                    @change="handleChangeMobileAndCheckExist"
                                  />
                                </div>
                                <p
                                  class="text-danger small"
                                  v-show="c_isShortMobileWrongFmt"
                                >
                                  电话号码格式不正确。
                                </p>
                                <p
                                  class="text-danger small"
                                  v-show="false === isMobileExist"
                                >
                                  您的手机号未注册品职账号，请您注册账号后再登录
                                </p>
                              </div>
                              <div class="mb-3">
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control form-control-lg"
                                    name="mobileCode"
                                    placeholder="6位数字"
                                    aria-describedby="button-addon2"
                                    size="6"
                                    v-model="mobileCode"
                                    @change="handleMobileCodeChange"
                                    @keydown.enter="doLogin"
                                  />
                                  <div class="input-group-append">
                                    <button
                                      class="btn btn-link border text-dark phone-code"
                                      :class="
                                        !c_isMobileReadyAndMobileCodeCounterOkAndMobileExist
                                          ? 'ofDisabled'
                                          : ''
                                      "
                                      type="button"
                                      id="button-addon200"
                                      @click.prevent="
                                        getMobileCodeLogin(
                                          !c_isMobileReadyAndMobileCodeCounterOkAndMobileExist
                                        )
                                      "
                                    >
                                      {{ c_mobileCodeBtnTxt }}
                                    </button>
                                  </div>
                                </div>
                                <p
                                  class="text-danger"
                                  v-show="errMessageMobileCode"
                                >
                                  {{ errMessageMobileCode }}
                                </p>
                                <!-- <p class="text-danger" v-if="isInvalid">{{ loginMessage }}</p> -->
                              </div>
                            </form>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center mb-4"
                        >
                          <div
                            class="nav nav-tabs login-type-tabs border-0 f-14"
                            id="nav-tab"
                            role="tablist"
                          >
                            <a
                              class="nav-link px-0 text-info border-0 active"
                              id="nav-mail-tab"
                              data-toggle="tab"
                              href="#nav-mail"
                              role="tab"
                              aria-controls="nav-mail"
                              aria-selected="true"
                              @click="setLoginType('passwd')"
                              >账号密码登录</a
                            >
                            <a
                              class="nav-link px-0 text-info border-0"
                              id="nav-phone-tab"
                              data-toggle="tab"
                              href="#nav-phone"
                              role="tab"
                              aria-controls="nav-phone"
                              aria-selected="false"
                              @click="setLoginType('sms')"
                              >手机验证码登录</a
                            >
                          </div>

                          <div class="f-14 text-right">客服咨询</div>
                        </div>

                        <p class="text-danger small" v-if="isInvalid">
                          {{ loginMessage }}
                        </p>
                        <button
                          type="button"
                          @click.prevent="doLogin"
                          class="btn btn-lg btn-primary btn-block"
                        >
                          {{ loading ? '登录中...' : '登录' }}
                        </button>
                      </form>
                    </div>

                    <!-- 注册 -->
                    <div
                      class="tab-pane fade"
                      id="nav-register"
                      role="tabpanel"
                      aria-labelledby="nav-register-tab"
                    >
                      <form id="formMobileModal">
                        <div class="mb-4">
                          <div class="input-group input-group-lg">
                            <div class="input-group-prepend phone-reg dropup">
                              <button
                                class="btn btn-link border text-dark dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                data-offset="-10,-50"
                                @click.prevent="toggleRegionList"
                              >
                                {{ regionCountry + region }}
                              </button>
                              <div
                                class="dropdown-menu shadow"
                                :class="`${isRegionShown ? '' : 'd-none'}`"
                              >
                                <a
                                  href="javascript:undefined"
                                  @click.prevent="setRegionNo(regionNo)"
                                  class="dropdown-item"
                                  :key="`region-${idx}`"
                                  v-for="(regionNo, idx) in ms_regionNo"
                                >
                                  {{ regionNo.countryName }}
                                  <span>{{ regionNo.countryNumber }}</span>
                                </a>
                              </div>
                            </div>
                            <input
                              type
                              class="form-control"
                              name="shortMobile"
                              placeholder="输入手机号"
                              v-model="shortMobile"
                              @input="handleInputMobileAndCheckExist"
                              @change="handleChangeMobileAndCheckExist"
                            />
                          </div>
                          <p
                            class="text-danger small"
                            v-show="c_isShortMobileWrongFmt"
                          >
                            电话号码格式不正确。
                          </p>
                          <p
                            class="text-danger small"
                            v-show="true === isMobileExist"
                          >
                            您的手机号已注册品职账号，请您直接登陆
                          </p>
                        </div>
                        <div class="mb-4">
                          <div class="input-group">
                            <input
                              type="text"
                              class="form-control form-control-lg"
                              placeholder="6位数字"
                              aria-describedby="button-addon2"
                              size="6"
                              v-model="mobileCode"
                              @change="handleMobileCodeChange"
                            />
                            <div class="input-group-append">
                              <button
                                class="btn btn-link border text-dark phone-code"
                                :class="
                                  !c_isMobileReadyAndMobileCodeCounterOkAndNotMobileExist
                                    ? 'ofDisabled'
                                    : ''
                                "
                                type="button"
                                id="button-addon210"
                                @click.prevent="
                                  getMobileCodeLoginUniqueGlobal(
                                    !c_isMobileReadyAndMobileCodeCounterOkAndNotMobileExist
                                  )
                                "
                              >
                                {{ c_mobileCodeBtnTxt }}
                              </button>
                            </div>
                          </div>
                          <p
                            class="text-danger small"
                            v-show="errMessageMobileCode"
                          >
                            {{ errMessageMobileCode }}
                          </p>
                          <p class="text-danger small" v-if="isInvalid">
                            {{ loginMessage }}
                          </p>
                        </div>

                        <p class="small text-center mb-4">
                          注册即代表同意
                          <a
                            href="https://resources.pzacademy.com/legal.html"
                            target="_blank"
                            class="text-dark"
                            >《品职学员协议》</a
                          >
                          <a
                            href="https://resources.pzacademy.com/privacy.html"
                            target="_blank"
                            class="text-dark"
                            >《隐私保护协议》</a
                          >
                        </p>
                        <button
                          type="button"
                          @click.prevent="postSmsRegisterMobilePrecheck"
                          class="btn btn-primary btn-block btn-lg"
                        >
                          {{ loading ? '注册中...' : '注册' }}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>

                <div class="card-footer" v-if="false">
                  <div class="d-flex justify-content-center align-items-center">
                    <button
                      class="btn btn-link text-dark"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapse-wx-code"
                      aria-expanded="false"
                      aria-controls="collapse-wx-code"
                      @click.once="handleWechatLoginClick"
                      ref="btnWechatLogin"
                    >
                      <svg
                        class="mr-1"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <title>微信</title>
                        <g
                          id="页面-1"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            id="画板"
                            transform="translate(-203.000000, -150.000000)"
                            fill-rule="nonzero"
                          >
                            <g
                              id="微信"
                              transform="translate(203.000000, 150.000000)"
                            >
                              <rect
                                id="矩形"
                                fill="#000000"
                                opacity="0"
                                x="0"
                                y="0"
                                width="30"
                                height="30"
                              />
                              <path
                                d="M30,18.15 C30,13.95 25.95,10.65 21,10.65 C16.05,10.65 12,13.95 12,18.15 C12,22.35 16.05,25.65 21,25.65 C21.9,25.65 22.8,25.5 23.7,25.35 L26.55,26.85 L25.8,24.6 C28.35,23.1 30,20.85 30,18.15 L30,18.15 Z M17.85,16.95 C16.95,16.95 16.35,16.35 16.35,15.45 C16.35,14.55 16.95,13.95 17.85,13.95 C18.75,13.95 19.35,14.55 19.35,15.45 C19.35,16.2 18.6,16.95 17.85,16.95 Z M24,16.95 C23.1,16.95 22.5,16.35 22.5,15.45 C22.5,14.55 23.1,13.95 24,13.95 C24.9,13.95 25.5,14.55 25.5,15.45 C25.5,16.2 24.75,16.95 24,16.95 Z"
                                id="形状"
                                fill="#4CBF00"
                              />
                              <path
                                d="M10.5,17.85 C10.5,13.2 15,9.45 20.7,9.45 L21.15,9.45 C19.95,5.55 15.9,2.55 10.8,2.55 C4.8,2.55 0,6.6 0,11.55 C0,14.7 1.95,17.55 4.95,19.05 L4.05,21.75 L7.5,20.1 C8.55,20.4 9.6,20.55 10.8,20.55 L11.1,20.55 C10.65,19.65 10.5,18.75 10.5,17.85 L10.5,17.85 Z M14.55,5.7 C15.6,5.7 16.5,6.6 16.5,7.65 C16.5,8.7 15.6,9.6 14.55,9.6 C13.5,9.45 12.6,8.55 12.6,7.5 C12.6,6.45 13.5,5.7 14.55,5.7 L14.55,5.7 Z M7.2,9.45 C6.15,9.45 5.4,8.55 5.4,7.5 C5.4,6.45 6.3,5.55 7.35,5.55 C8.4,5.55 9.15,6.45 9.15,7.5 C9.15,8.55 8.25,9.45 7.2,9.45 Z"
                                id="形状"
                                fill="#4CBF00"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                      微信扫码登录
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- 新用户设置密码&邮箱 -->
            <div
              class="pz-id-sync"
              v-if="!c_isLogin && 'isRegisterMobile' === step"
            >
              <div class="card border-0">
                <div class="card-body">
                  <form id="formEmailBindModal">
                    <div class="mb-4 text-center">
                      <h4 class="mb-3">设置昵称和密码</h4>
                      <p class="small">
                        设置密码后，可以使用手机号+密码进行登录网站。
                      </p>
                    </div>
                    <!-- <div class="mb-4">
                    <div class="form-group mb-3">
                      <input
                        type="text"
                        v-model="username"
                        @change="clearError()"
                        class="form-control form-control-lg"
                        name="email"
                        placeholder="填写邮箱地址"
                        id="validationTooltip01"
                      />
                    </div>
                  </div>-->
                    <div class="mb-4">
                      <div class="form-group mb-3">
                        <input
                          type="text"
                          v-model="nickname"
                          @input="handleInputNickname"
                          class="form-control form-control-lg"
                          name="nickname"
                          placeholder="填写昵称"
                          autocomplete="off"
                        />
                      </div>
                      <!-- 错误信息 -->
                      <p
                        class="small text-danger"
                        v-show="c_isShowNotNicknameMatchFormat"
                      >
                        昵称应为4-32个字符，一个汉字算两个字符。
                      </p>
                      <p
                        class="small text-danger"
                        v-show="c_isShowNotNicknameIsUnique"
                      >
                        你的名字太火爆，已经被人抢先一步，如果你仍对它情有独钟，我们也无法阻拦
                      </p>
                    </div>
                    <div class="mb-5">
                      <div class="form-group mb-3">
                        <input
                          :type="isShowNewPassword ? 'text' : 'password'"
                          v-model="newPassword"
                          @input="handleInputNewPassword"
                          class="form-control form-control-lg"
                          name="password"
                          placeholder="设置登录密码"
                          autocomplete="off"
                          id="validationTooltip0210"
                        />
                        <div class="input-group-append">
                          <button
                            class="btn btn-link border text-dark btn-password phone-code"
                            :class="!isShowNewPassword ? 'active' : ''"
                            type="button"
                            data-toggle="button"
                            aria-pressed="false"
                            @click.prevent="toggleNewPassword"
                          >
                            <svg width="24px" height="24px" viewBox="0 0 24 24">
                              <g
                                id="off"
                                class="off"
                                fill="#666666"
                                fill-rule="nonzero"
                              >
                                <path
                                  d="M12.0719496,14.4139103 C7.88448087,14.4139103 3.98001398,12.1594884 1.87908464,8.53082843 C1.57209954,8.00079945 1.75437195,7.32447288 2.28200259,7.01748776 C2.81203158,6.71050266 3.49075648,6.89277506 3.79534327,7.42040571 C5.50054962,10.3655441 8.6711302,12.1954632 12.0695513,12.1954632 C15.4679724,12.1954632 18.638553,10.3655441 20.3437594,7.4180074 C20.6507445,6.88797841 21.3270711,6.70570601 21.8571,7.01269111 C22.387129,7.31967621 22.5670031,7.9960028 22.2624163,8.52603178 C20.1638853,12.1594884 16.2594184,14.4139103 12.0719496,14.4139103 Z M6.33036874,15.517138 C6.13610473,15.517138 5.93704406,15.4667733 5.7595683,15.3588488 C5.23433597,15.0422704 5.06645348,14.3611472 5.38303188,13.8383132 L6.60617569,11.8141301 C6.92275409,11.2888978 7.6038773,11.1234136 8.1267113,11.4375937 C8.65194363,11.7541721 8.81982612,12.4352953 8.50324772,12.9581293 L7.28010394,14.9823124 C7.07145,15.3252723 6.70690519,15.517138 6.33036874,15.517138 L6.33036874,15.517138 Z M17.7535725,15.517138 C17.3794344,15.517138 17.0124913,15.3276706 16.8038373,14.9823124 L15.5806935,12.9581293 C15.2641151,12.432897 15.4319976,11.7541721 15.9548316,11.4375937 C16.4800639,11.1210153 17.1587888,11.2888978 17.4753672,11.8117318 L18.698511,13.8359149 C19.0150894,14.3611472 18.847207,15.0398721 18.3243729,15.3564505 C18.1468972,15.4643749 17.9478365,15.517138 17.7535725,15.517138 Z M12.0719496,16.958529 C11.4603777,16.958529 10.9639252,16.4620765 10.9639252,15.8505046 L10.9639252,13.3058859 C10.9639252,12.694314 11.4603777,12.1978615 12.0719496,12.1978615 C12.6835215,12.1978615 13.179974,12.694314 13.179974,13.3058859 L13.179974,15.8505046 C13.179974,16.4620765 12.6835215,16.958529 12.0719496,16.958529 Z"
                                />
                              </g>
                              <g
                                id="on"
                                class="on"
                                fill="#666666"
                                fill-rule="nonzero"
                              >
                                <path
                                  d="M23.8766667,11.2666667 C23.8766667,11.2666667 23.7766667,10.9666667 23.6766667,10.8666667 L23.1766667,9.86666667 C22.6766667,9.06666668 21.9766667,8.06666667 20.9766667,6.96666666 C19.0766667,4.86666666 16.0766667,2.66666667 11.9766667,2.66666667 C7.87666664,2.66666667 4.87666666,4.86666668 2.97666666,6.96666666 C1.97666665,8.06666665 1.27666666,9.06666666 0.776666672,9.86666667 C0.57666668,10.2666667 0.376666664,10.5666667 0.276666656,10.8666667 C0.176666648,10.9666667 0.0766666641,11.2666667 0.0766666641,11.2666667 C-0.0233333437,11.5666667 -0.0233333437,11.8666667 0.0766666641,12.0666667 C0.0766666641,12.0666667 0.176666672,12.3666667 0.276666656,12.4666667 L0.776666672,13.4666667 C1.27666666,14.2666667 1.97666667,15.2666667 2.97666666,16.3666667 C4.87666666,18.4666667 7.87666666,20.6666667 11.9766667,20.6666667 C16.0766666,20.6666667 19.0766666,18.4666667 20.9766667,16.3666667 C21.9766667,15.2666667 22.6766666,14.2666667 23.1766667,13.4666667 C23.3766667,13.0666667 23.5766667,12.7666667 23.6766667,12.4666667 C23.7766667,12.3666667 23.8766666,12.0666667 23.8766667,12.0666667 C23.9766667,11.7666667 23.9766667,11.5666667 23.8766667,11.2666667 Z M21.4766667,12.3666667 C21.0766667,13.0666667 20.3766667,14.0666666 19.5766667,14.9666667 C17.7766667,16.8666667 15.2766667,18.6666667 11.9766667,18.6666667 C8.67666666,18.6666667 6.17666665,16.8666667 4.37666667,14.9666667 C3.47666667,14.0666667 2.87666667,13.0666667 2.47666666,12.3666667 C2.27666667,12.0666667 2.17666666,11.8666667 2.07666666,11.6666667 C2.17666666,11.4666667 2.27666665,11.2666667 2.47666666,10.9666667 C2.97666666,10.2666667 3.57666666,9.26666667 4.37666667,8.36666667 C6.17666667,6.46666666 8.67666666,4.66666666 11.9766667,4.66666666 C15.2766667,4.66666666 17.7766667,6.46666666 19.5766667,8.36666667 C20.4766667,9.26666667 21.0766667,10.2666667 21.4766667,10.9666667 C21.6766667,11.2666667 21.7766667,11.4666667 21.8766667,11.6666667 C21.7766666,11.8666667 21.5766667,12.0666667 21.4766667,12.3666667 Z"
                                />
                                <path
                                  d="M11.9766667,8.06666667 C10.1766667,8.06666667 8.57666667,9.66666668 8.57666667,11.6666667 C8.57666667,13.6666667 10.1766667,15.2666667 11.9766667,15.2666667 C13.7766667,15.2666667 15.3766667,13.6666667 15.3766667,11.6666667 C15.3766667,9.66666668 13.7766667,8.06666667 11.9766667,8.06666667 Z M6.57666666,11.6666667 C6.57666666,8.66666667 8.97666666,6.06666666 11.9766667,6.06666666 C14.9766667,6.06666666 17.3766667,8.66666665 17.3766667,11.6666667 C17.3766667,14.6666667 14.9766667,17.2666667 11.9766667,17.2666667 C8.97666666,17.2666667 6.57666666,14.6666667 6.57666666,11.6666667 Z"
                                />
                              </g>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <p
                      class="small text-danger"
                      v-show="c_isShowNewPasswordInvalid"
                    >
                      密码应为至少8位的数字和字母组合。
                    </p>

                    <p class="text-danger small" v-if="isInvalid">
                      {{ loginMessage }}
                    </p>

                    <button
                      type="button"
                      :disabled="c_isPostLoginSmsRegisterNewUserDisabled"
                      @click.prevent="postLoginSmsRegisterNewUser"
                      class="btn btn-primary btn-lg btn-block mt-4 mb-4"
                    >
                      {{ loading ? '进入中...' : '进入品职' }}
                    </button>
                    <!-- <button
                    type="button"
                    class="btn btn-link btn-block"
                    @click.prevent="afterLoginPhone"
                  >稍后设置</button>-->
                    <button
                      type="button"
                      class="btn btn-link btn-block"
                      @click.prevent="setStepBlank"
                    >
                      返回
                    </button>
                  </form>
                </div>
              </div>
            </div>

            <!-- 手机绑定 -->
            <div
              class="pz-id-sync"
              v-if="
                (!c_isLogin && 'wechatBinding' === step) ||
                (c_isLogin && !mg_userInfo.mobile)
              "
            >
              <div class="card border-0">
                <div class="card-body">
                  <form id="formMobileBindModal">
                    <div class="mb-5 mt-3 text-center">
                      <h4>请绑定手机</h4>
                    </div>
                    <div class="mb-4">
                      <div class="input-group input-group-lg">
                        <div class="input-group-prepend phone-reg dropup">
                          <button
                            class="btn btn-link border text-dark dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            data-offset="-10,-50"
                            @click.prevent="toggleRegionList"
                          >
                            {{ regionCountry + region }}
                          </button>
                          <div
                            class="dropdown-menu shadow"
                            :class="`${isRegionShown ? '' : 'd-none'}`"
                          >
                            <a
                              href="javascript:undefined"
                              @click.prevent="setRegionNo(regionNo)"
                              class="dropdown-item"
                              :key="`region-${idx}`"
                              v-for="(regionNo, idx) in ms_regionNo"
                            >
                              {{ regionNo.countryName }}
                              <span>{{ regionNo.countryNumber }}</span>
                            </a>
                          </div>
                        </div>
                        <template>
                          <input
                            type="text"
                            class="form-control"
                            name="shortMobile"
                            placeholder="输入手机号"
                            v-model="shortMobile"
                            @change="handleChangeMobile"
                            v-if="!c_isLogin && 'wechatBinding' === step"
                          />
                          <input
                            type="text"
                            class="form-control"
                            name="shortMobile"
                            placeholder="输入手机号"
                            v-model="shortMobile"
                            @input="handleInputMobileAndCheckExist"
                            @change="handleChangeMobileAndCheckExist"
                            v-if="c_isLogin && !mg_userInfo.mobile"
                          />
                        </template>
                      </div>
                      <p class="text-danger" v-show="c_isShortMobileWrongFmt">
                        电话号码格式不正确。
                      </p>
                      <p
                        class="text-danger small"
                        v-show="
                          true === isMobileExist &&
                          c_isLogin &&
                          !mg_userInfo.mobile
                        "
                      >
                        您输入的手机号已被绑定，请使用该手机直接登录或绑定其它手机号。
                      </p>
                    </div>
                    <div class="mb-5">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control form-control-lg"
                          placeholder="6位数字"
                          aria-describedby="button-addon2"
                          name="mobileCode"
                          size="6"
                          v-model="mobileCode"
                          @change="handleMobileCodeChange"
                        />
                        <div class="input-group-append">
                          <template>
                            <button
                              class="btn btn-link border text-dark phone-code"
                              :class="
                                !c_isMobileReadyAndMobileCodeCounterOk
                                  ? 'ofDisabled'
                                  : ''
                              "
                              type="button"
                              id="button-addon220"
                              @click.prevent="
                                getMobileCodeLogin(
                                  !c_isMobileReadyAndMobileCodeCounterOk
                                )
                              "
                              v-if="!c_isLogin && 'wechatBinding' === step"
                            >
                              {{ c_mobileCodeBtnTxt }}
                            </button>
                            <button
                              class="btn btn-link border text-dark phone-code"
                              :class="
                                !c_isMobileReadyAndMobileCodeCounterOkAndNotMobileExist
                                  ? 'ofDisabled'
                                  : ''
                              "
                              type="button"
                              id="button-addon230"
                              @click.prevent="
                                getMobileCodeLogin(
                                  !c_isMobileReadyAndMobileCodeCounterOkAndNotMobileExist
                                )
                              "
                              v-if="c_isLogin && !mg_userInfo.mobile"
                            >
                              {{ c_mobileCodeBtnTxt }}
                            </button>
                          </template>
                        </div>
                      </div>
                      <p class="text-danger" v-show="errMessageMobileCode">
                        {{ errMessageMobileCode }}
                      </p>
                      <p class="text-danger" v-if="isInvalid">
                        {{ loginPhoneMessage }}
                      </p>
                    </div>
                    <template>
                      <button
                        type="button"
                        @click.prevent="postSmsRegisterWechatPrecheck"
                        class="btn btn-primary btn-lg btn-block mt-4 mb-4"
                        v-if="!c_isLogin && 'wechatBinding' === step"
                      >
                        {{ loading ? '进入中...' : '进入品职' }}
                      </button>
                      <button
                        type="button"
                        @click.prevent="postLoginBindMobileFromForm"
                        class="btn btn-primary btn-lg btn-block mt-4 mb-4"
                        v-if="c_isLogin && !mg_userInfo.mobile"
                      >
                        {{ loading ? '进入中...' : '进入品职' }}
                      </button>
                    </template>
                    <template>
                      <button
                        type="button"
                        class="btn btn-link btn-block"
                        @click.prevent="setStepBlank"
                        v-if="!c_isLogin && 'wechatBinding' === step"
                      >
                        返回
                      </button>
                      <button
                        type="button"
                        class="btn btn-link btn-block"
                        @click.prevent="backToLogin"
                        v-if="c_isLogin && !mg_userInfo.mobile"
                      >
                        返回
                      </button>
                    </template>
                  </form>
                </div>
              </div>
            </div>

            <!-- 手机绑定-多账号检测 -->
            <div class="pz-id-set-phone" v-if="c_isLogin && mg_userInfo.mobile">
              <div class="new-phone collapse shadow" id="collapse-new-phone">
                <div class="py-4 px-1">
                  <h5 class="text-center">请绑定新手机</h5>
                </div>
                <div class="card-body">
                  <form id="formMobileBindNewModal">
                    <div class="mb-4">
                      <div class="input-group input-group-lg">
                        <div class="input-group-prepend phone-reg dropup">
                          <button
                            class="btn btn-link border text-dark dropdown-toggle"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            data-offset="-10,-50"
                            @click.prevent="toggleRegionList"
                          >
                            {{ regionCountry + region }}
                          </button>
                          <div
                            class="dropdown-menu shadow"
                            :class="`${isRegionShown ? '' : 'd-none'}`"
                          >
                            <a
                              href="javascript:undefined"
                              @click.prevent="setRegionNo(regionNo)"
                              class="dropdown-item"
                              :key="`region-${idx}`"
                              v-for="(regionNo, idx) in ms_regionNo"
                            >
                              {{ regionNo.countryName }}
                              <span>{{ regionNo.countryNumber }}</span>
                            </a>
                          </div>
                        </div>
                        <input
                          type
                          class="form-control"
                          name="shortMobile"
                          placeholder="输入手机号"
                          v-model="shortMobile"
                          @input="handleInputMobileAndCheckExist"
                          @change="handleChangeMobileAndCheckExist"
                        />
                      </div>
                      <p class="text-danger" v-show="c_isShortMobileWrongFmt">
                        电话号码格式不正确。
                      </p>
                    </div>
                    <div class="mb-4">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control form-control-lg"
                          placeholder="6位数字"
                          aria-describedby="button-addon2"
                          name="mobileCode"
                          size="6"
                          v-model="mobileCode"
                          @change="handleMobileCodeChange"
                        />
                        <div class="input-group-append">
                          <button
                            class="btn btn-link border text-dark phone-code"
                            :class="
                              !c_isMobileReadyAndMobileCodeCounterOkAndNotMobileExist
                                ? 'ofDisabled'
                                : ''
                            "
                            type="button"
                            id="button-addon240"
                            @click.prevent="
                              getMobileCodeLogin(
                                !c_isMobileReadyAndMobileCodeCounterOkAndNotMobileExist
                              )
                            "
                          >
                            {{ c_mobileCodeBtnTxt }}
                          </button>
                        </div>
                      </div>
                      <p class="text-danger" v-show="errMessageMobileCode">
                        {{ errMessageMobileCode }}
                      </p>
                      <p class="text-danger" v-if="isInvalid">
                        {{ loginPhoneMessage }}
                      </p>
                    </div>

                    <button
                      type="button"
                      @click.prevent="postLoginBindMobileFromForm"
                      class="btn btn-primary btn-lg btn-block mb-4"
                    >
                      {{ loading ? '进入中...' : '进入品职' }}
                    </button>

                    <button
                      class="btn btn-link btn-block"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapse-new-phone"
                      aria-expanded="false"
                      aria-controls="collapse-new-phone"
                    >
                      返回
                    </button>
                  </form>
                </div>
              </div>
              <div class="card border-0">
                <div class="card-body">
                  <form id="formMobileBindOldModal">
                    <div class="mb-5 mt-3 text-center">
                      <h4>请验证手机</h4>
                    </div>
                    <p class="text-danger">
                      您预留的手机号可能绑定多个品种账户，或者手机格式不正确。应《中华人民共和国网络安全法》要求，为了更好保障您的账号安全。
                    </p>
                    <p>
                      请重新验证手机号：
                      <strong>{{ mg_userInfo.mobile }}</strong>
                    </p>
                    <div class="mb-3">
                      <div class="input-group border">
                        <input
                          type="text"
                          class="form-control form-control-lg"
                          placeholder="6位数字"
                          aria-describedby="button-addon2"
                          name="mobileCode"
                          size="6"
                          v-model="mobileCode"
                          @change="handleMobileCodeChange"
                        />
                        <div class="input-group-append">
                          <button
                            class="btn btn-link border text-dark phone-code"
                            :class="
                              !c_isMobileCodeCounterOk ? 'ofDisabled' : ''
                            "
                            type="button"
                            id="button-addon250"
                            @click.prevent="
                              getMobileCodeLoginWithoutMobile(
                                !c_isMobileCodeCounterOk
                              )
                            "
                          >
                            {{ c_mobileCodeBtnTxt }}
                          </button>
                        </div>
                      </div>
                      <p class="text-danger" v-show="errMessageMobileCode">
                        {{ errMessageMobileCode }}
                      </p>
                      <p class="text-danger" v-if="isInvalid">
                        {{ loginPhoneMessage }}
                      </p>
                    </div>

                    <button
                      type="button"
                      @click.prevent="postLoginBindMobileFromUserInfo"
                      class="btn btn-primary btn-lg btn-block mt-4 mb-4"
                    >
                      {{ loading ? '进入中...' : '进入品职' }}
                    </button>
                    <!-- <button class="btn btn-link btn-block" @click.prevent="backToLogin">返回</button> -->

                    <button
                      class="btn btn-link text-info mb-4"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapse-new-phone"
                      aria-expanded="false"
                      aria-controls="collapse-new-phone"
                    >
                      更换手机号
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="modal-body p-0">
          <div :class="`pz-id-login mx-auto ${step === '' ? '' : 'd-none'}`">
            <div class="card border-0">
              <div class="card-body d-flex justify-content-center align-items-center p-0">
                <div class="tab-content" id="myTabContent">
                  <div
                    class="tab-pane fade show active pb-3"
                    id="wx"
                    role="tabpanel"
                    aria-labelledby="wx-tab"
                  >
                    <div class="d-flex flex-column justify-content-center align-items-center">
                      <div class="text-center">
                        <h5 class="mb-2">请扫码注册</h5>
                        <h5 class="text-secondary font-weight-normal">体验更多的学习乐趣</h5>
                      </div>
                      <div id="loginModalHome">
                        <template v-if="ms_isWechatBrowser">
                          <img
                            :src="wechatQrImgUrl"
                            class="figure-img img-fluid"
                            width="220px"
                            height="220px"
                          />
                        </template>
                      </div>
                      <p class="small mb-0 mb-xl-3 text-nowrap">
                        品职启用更安全省心的
                        <span class>
                          <svg
                            width="22px"
                            height="18px"
                            viewBox="0 0 22 18"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <title>微信</title>
                            <g
                              id="Page-1"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g id="微信" fill="#00cc00" fill-rule="nonzero">
                                <path
                                  d="M10.7452342,5.26438268 C11.3163776,5.26613671 11.7255943,4.88332141 11.744954,4.3271395 C11.7669549,3.71639428 11.3225373,3.25085644 10.7223535,3.25525644 C9.97256414,3.26229672 9.52198595,3.66183277 9.5325456,4.3104184 C9.54310603,4.90092143 9.99984489,5.26085735 10.746115,5.26438268 L10.7452342,5.26438268 Z M5.25997302,3.25526366 C4.54450479,3.23942303 4.06928441,3.61783814 4.0516844,4.21890263 C4.03408369,4.82084604 4.51810296,5.24590311 5.25117301,5.2705453 C5.87335861,5.29078605 6.25177346,4.92293048 6.25881383,4.29106596 C6.26585411,3.5870381 5.96224123,3.27110584 5.25997302,3.25526366 L5.25997302,3.25526366 Z M15.5326308,5.37702975 C10.9168489,5.04965712 7.32718122,8.76340923 8.47210292,13.2841526 C7.51638504,13.1767883 6.58970214,13.1371866 5.69470361,12.9497395 C5.01267578,12.8071738 4.48113426,13.0289427 3.92759271,13.3184737 L2.41305255,14.0981841 L3.15668225,11.8734565 C2.03287625,11.0884653 1.10355118,10.1292263 0.531532501,8.8619798 C-0.363464226,6.88190542 -0.100332023,4.98631185 1.11323553,3.25879557 C2.80290418,0.853664113 5.27140257,-0.0554115463 8.11214895,0.00266563052 C10.3034344,0.048427486 12.2289509,0.877420169 13.8763719,2.33035484 C14.6701631,3.03086341 15.4780369,4.51108244 15.5326308,5.37615805 L15.5326308,5.37702975 Z M13.3070189,10.5577919 C13.8702411,10.561312 14.2900175,10.2022577 14.2574578,9.69535661 C14.2222563,9.16381509 13.8684815,8.95172691 13.3686225,8.93764617 C12.8740425,8.92356561 12.437545,9.29406101 12.4120239,9.7490392 C12.3917832,10.1028137 12.893404,10.5551515 13.3070207,10.5586726 L13.3070207,10.5577925 L13.3070189,10.5577919 Z M18.5907425,9.68039695 C18.576662,9.26942062 18.1313643,8.92708652 17.6183035,8.93500761 C17.0480409,8.94380797 16.679305,9.29934173 16.7145068,9.80800251 C16.7365077,10.1476962 17.2847695,10.6035552 17.6429439,10.5815533 C18.1269625,10.550752 18.6048233,10.096654 18.5907425,9.68039695 L18.5907425,9.68039695 Z M19.6291834,17.7036741 C19.2155667,17.4836648 18.8186711,17.2222941 18.384814,17.0559674 C18.0380799,16.922202 17.6103825,16.7681966 17.2803695,16.8561985 C15.1128346,17.4326208 13.0870096,17.1052482 11.2697246,15.8599981 C8.79242074,14.1659294 8.00567172,11.0180436 9.83966702,8.50025898 C11.7378955,5.8944743 15.5801393,5.26701339 18.3020784,6.46737731 C19.9891067,7.21100701 21.2554779,8.37266244 21.795823,10.1925644 C22.3132838,11.9297542 21.8275043,13.4178871 20.5989748,14.694827 C20.2381599,15.0670822 19.821024,15.3865355 19.4927706,15.7834311 C19.3695656,15.9330371 19.3669256,16.23929 19.4091673,16.4540186 C19.4830902,16.8324334 19.6353362,17.1976483 19.7541417,17.5672631 L19.6291767,17.7036741 L19.6291834,17.7036741 Z"
                                  id="形状"
                                />
                              </g>
                            </g></svg
                          >微信扫码直接登录
                        </span>
                      </p>
                      <div class="text-danger" v-if="isInvalid">{{ loginMessage }}</div>
                    </div>
                  </div>

                  <div
                    class="tab-pane fade pb-5"
                    id="mail"
                    role="tabpanel"
                    aria-labelledby="mail-tab"
                  >
                    <div class="mb-4 text-center">
                      <h5 class="mb-2">账号登录</h5>
                      <h5 class="text-secondary font-weight-normal">输入您的邮箱和密码</h5>
                    </div>
                    <div class="form-group mb-3">
                      <input
                        type="email"
                        v-model="username"
                        @change="clearError()"
                        class="form-control form-control-lg"
                        name="email"
                        placeholder="Email"
                        id="validationTooltip01"
                      />
                    </div>
                    <div class="form-group">
                      <input
                        type="password"
                        v-model="password"
                        @change="clearError()"
                        class="form-control form-control-lg"
                        name="password"
                        placeholder="Password"
                        id="validationTooltip02"
                      />

                      <div class="text-danger" v-if="isInvalid">{{ loginMessage }}</div>
                    </div>
                    <a
                      class="text-dark mb-4 mb-lg-0"
                      :href="PASSWORD_FORGET_PAGE"
                      @click.prevent="passwdForget"
                      >忘记密码?</a
                    >
                    <button
                      type="button"
                      @click="doLogin()"
                      class="btn btn-primary btn-lg btn-block mt-5"
                    >
                      {{ loading ? '登录中...' : '邮箱登录' }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-footer bg-light">
                <nav
                  class="nav nav-tabs login-tabs card-header-tabs mb-0"
                  id="myTab"
                  role="tablist"
                >
                  <a
                    class="nav-link text-success active"
                    id="wx-tab"
                    data-toggle="tab"
                    href="#wx"
                    role="tab"
                    aria-controls="wx"
                    aria-selected="true"
                  >
                    使用微信扫码登录
                    <i class="pz-icon icon-chevron-right"></i>
                  </a>
                  <a
                    class="nav-link text-info"
                    id="mail-tab"
                    data-toggle="tab"
                    href="#mail"
                    role="tab"
                    aria-controls="mail"
                    aria-selected="false"
                  >
                    使用邮箱密码登录
                    <i class="pz-icon icon-chevron-right"></i>
                  </a>
                </nav>
              </div>
            </div>
          </div>

          <div :class="`pz-id-select ${step === 'chooseUser' ? '' : 'd-none'}`">
            <div class="card p-3">
              <div class="card-header border-bottom-0 pt-5 bg-white">
                <div class="d-flex flex-column align-items-center justify-content-center">
                  <div
                    class="user-photo user-photo-lg mb-3 rounded-lg"
                    :style="{ backgroundImage: 'url(' + wechatUser.headimgurl + ')' }"
                  ></div>
                  <h3>Hi, {{ wechatUser.nickname }}</h3>
                </div>
              </div>

              <div class="card-body">
                <p class="text-muted">请从下面选择一种方式进行登录。</p>
                <div class="list-group list-group-flush border-bottom">
                  <a
                    href="javascript:undefined"
                    class="list-group-item list-group-item-action py-3 px-2"
                    @click.prevent="doLoginWeChatNewUser"
                  >
                    <div class="media">
                      <div class="mr-3 align-self-center">
                        <i class="pz-icon icon-user-identity icons-lg text-info"></i>
                      </div>
                      <div class="media-body">
                        <h5 class="font-weight-normal">我是新用户</h5>
                        <p class="mb-0 text-muted">系统自动为你创建一个账号</p>
                      </div>
                      <div class="ml-3 align-self-center">
                        <i class="pz-icon icon-chevron-right text-muted"></i>
                      </div>
                    </div>
                  </a>
                  <a
                    href="javascript:undefined"
                    class="list-group-item list-group-item-action py-2 px-2"
                    @click.prevent="doLoginWeChatOldUser"
                  >
                    <div class="media">
                      <div class="mr-3 align-self-center">
                        <i class="pz-icon icon-user-group icons-lg text-primary"></i>
                      </div>
                      <div class="media-body">
                        <h5 class="font-weight-normal">我是老用户</h5>
                        <p class="mb-0 text-muted">关联你之前注册的品职账号</p>
                      </div>
                      <div class="ml-3 align-self-center">
                        <i class="pz-icon icon-chevron-right text-muted"></i>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div :class="`pz-id-sync ${step === 'bind' ? '' : 'd-none'}`">
            <div class="card py-6">
              <div class="card-header border-bottom-0 pt-5 bg-white">
                <div class="d-flex flex-column align-items-center justify-content-center">
                  <div
                    class="user-photo user-photo-lg mb-3 rounded-lg"
                    :style="{ backgroundImage: 'url(' + wechatUser.headimgurl + ')' }"
                  ></div>
                  <h3>Hi, {{ wechatUser.nickname }}</h3>
                </div>
              </div>
              <div class="card-body px-5">
                <p class="text-muted">请输入你的品职账号进行关联。</p>
                <div class="form-group">
                  <input
                    type="email"
                    v-model="username"
                    @change="clearError()"
                    class="form-control"
                    name="email"
                    placeholder="Email"
                    id="validationTooltip03"
                  />
                </div>
                <div class="form-group">
                  <input
                    type="password"
                    v-model="password"
                    @change="clearError()"
                    class="form-control"
                    name="password"
                    placeholder="Password"
                    id="validationTooltip04"
                  />
                  <div class="text-danger" v-if="isInvalid">用户名或密码错误</div>
                </div>
                <button
                  type="button"
                  @click="doLoginWeChatBind"
                  class="btn btn-primary btn-block mt-5"
                >
                  {{ loading ? '正在关联...' : '关联账号' }}
                </button>
              </div>
            </div>
          </div>
          <div
            :class="`pz-id-sync-success animated fadeIn fast ${
              step === 'bindSucc' ? '' : 'd-none'
            }`"
          >
            <div class="card">
              <div class="card-header border-bottom-0 pt-5 bg-white">
                <h3>成功关联</h3>
                <p class="text-muted">下次进入，你可以任意选择使用微信账户或品职账号登录。</p>
              </div>
              <div class="card-body text-center">
                <div class="weixin-user my-5">
                  <div class="row row-sm-space">
                    <figure class="col-5">
                      <img
                        class="rounded-circle"
                        alt
                        width="90px"
                        height="90px"
                        :src="wechatUser.headimgurl"
                      />
                      <figcaption>{{ wechatUser.nickname }}</figcaption>
                      <small>微信</small>
                    </figure>
                    <figure class="col-2">
                      <i class="fa fa-arrows-h fa-2x text-muted mt-4"></i>
                    </figure>
                    <figure class="col-5">
                      <img
                        class="rounded-circle"
                        alt
                        width="90px"
                        height="90px"
                        :src="mg_userInfo.avatar"
                      />
                      <figcaption>{{ mg_userInfo.nickname }}</figcaption>
                      <small>品职</small>
                    </figure>
                  </div>
                </div>
                <div class="text-center">
                  <button
                    type="btn"
                    ng-click="doLogin()"
                    class="btn btn-primary px-5"
                    @click.prevent="doAfterLogin"
                  >进入学习</button>
                </div>
              </div>
            </div>
          </div>

          <div
            :class="`pz-id-sync-success animated fadeIn fast ${
              'chooseWebVersion' === step ? '' : 'd-none'
            }`"
          >
            <div class="card py-6">
              <div class="card-body text-center">
                <h5>请选择一个版本进入学习</h5>
                <p class="small text-muted">选择后，您也可以在用户中心里进行切换</p>
                <div class="btn-group btn-group-toggle big-rodio login-rodio" data-toggle="buttons">
                  <label class="btn btn-outline-light" @click.prevent="setPzWebVersion(2)">
                    <input type="radio" name="options" id="option1" autocomplete="off" checked />
                    <h4 class="text-dark">新版本</h4>
                    <span class="text-muted">尝试全新的学习体验</span>
                    <div class="btn-selected">
                      <i class="material-icons _lg">check</i>
                    </div>
                  </label>
                  <label class="btn btn-outline-light" @click.prevent="setPzWebVersion(1)">
                    <input type="radio" name="options" id="option2" autocomplete="off" />
                    <h4 class="text-dark">老版本</h4>
                    <span class="text-muted">我喜欢老版本学习</span>
                    <div class="btn-selected">
                      <i class="material-icons _lg">check</i>
                    </div>
                  </label>
                </div>
                <div class>
                  <button type="button" class="btn btn-primary px-7" @click.prevent="doAfterLogin">
                    确定
                  </button>
                </div>
              </div>
            </div>
          </div>

          <Spinner displayType="fixed" v-if="immLoading" :text="loadingMessage" />
        </div>-->
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="loginCaptchaModal"
      tabindex="-1"
      aria-labelledby="loginCaptchaModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-dialog-centered mx-auto"
        style="width: 310px"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="loginCaptchaModalLabel">
              请完成安全验证
            </h6>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="closeCaptcha"
            >
              <!-- <span aria-hidden="true">&times;</span> -->
              <i class="pz-icon icon-close"></i>
            </button>
          </div>
          <div class="modal-body">
            <div id="captcha" style="height: 196px"></div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>
<script>
import $ from 'jquery';
import { mapGetters, mapActions } from 'vuex';

import {
  LOGIN_PAGE_CHUNK_NAME,
  LOGIN_PHONE_PAGE_CHUNK_NAME,
  DASHBOARD_PAGE_CHUNK_NAME,
} from '@/constants';
import { PASSWORD_FORGET_PAGE } from '@/constants/routes';
import { LoginMixin } from '@/scripts/Login/Login.mixin';
import { LoginPhoneMixin } from '@/scripts/LoginPhone/LoginPhone.mixin';

export default {
  name: 'LoginModal',

  mixins: [LoginMixin, LoginPhoneMixin],

  data: () => {
    return {
      pzButtonId: '',
      PASSWORD_FORGET_PAGE,
    };
  },

  computed: {
    c_route_query_code() {
      return this.$route.query.code;
    },

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_isLogin() {
      return Boolean(this.mg_userInfo.studentId);
    },

    c_isPhoneValid() {
      return (
        this.c_isLogin &&
        this.mg_userInfo.profile &&
        this.mg_userInfo.profile.mobileValided
      );
    },

    c_isLoginModal() {
      return (
        LOGIN_PAGE_CHUNK_NAME !== this.$route.name &&
        LOGIN_PHONE_PAGE_CHUNK_NAME !== this.$route.name &&
        (!this.c_isLogin || !this.c_isPhoneValid)
      );
    },
  },

  methods: {
    ...mapActions({
      ma_getImportantMessage: 'getImportantMessage',
    }),

    closeLogin() {
      if (this.c_isLogin) {
        this.ma_logout();
      }
      this.step = '';
      //cookieSetItem('isLoginFromWechat', 'false');
    },

    showLoginModal() {
      $(this.$refs.pzLoginModal).modal('show');
    },

    passwdForget() {
      $(this.$refs.pzLoginModal).modal('hide');
      this.$router.push(PASSWORD_FORGET_PAGE);
    },

    _closeModalAndEmit() {
      $(this.$refs.pzLoginModal).modal('hide');
      if (this.pzButtonId) {
        this.$bus.emit(this.pzButtonId);
      }
      this.$bus.emit('login-modal-closed');
      this.pzButtonId = '';
      if (DASHBOARD_PAGE_CHUNK_NAME === this.$route.name) {
        this.ma_getImportantMessage();
      } else {
        window.localStorage.setItem('isLoginNotDashboard', 'true');
      }
    },

    afterLogin() {
      if (this.mg_userInfo.profile && this.mg_userInfo.profile.mobileValided) {
        this._closeModalAndEmit();
      } else {
        this._loginPhoneCreated();
      }
    },

    backToLogin() {
      this.ma_logout();
    },

    afterLoginPhone() {
      this._closeModalAndEmit();
    },
  },

  mounted() {
    this.$bus.on('setPzButtonId', ({ pzButtonId }) => {
      this.pzButtonId = pzButtonId;
      this._loginCreated();
      this._loginMounted();
    });

    $(this.$refs.pzLoginModal).on('show.bs.modal', () => {
      this.warnIfNoFingerPrint();
    });
  },

  beforeDestroy() {
    this.$bus.off('setPzButtonId');
  },
};
</script>
<style lang="scss" scoped>
.phone-code.ofDisabled {
  pointer-events: auto !important;
  cursor: not-allowed !important;
}
</style>
